/**
 * @phxComponentCommunicator
 */
import { CommunicatorService } from './lib/communicator';

angular
  .module('ui-ng-component-communicator', [])
  .service('ngComponentCommunicatorService', CommunicatorService)
  .directive('componentCommunicator', [
    'ngComponentCommunicatorService',
    '$parse',
    (ngComponentCommunicatorService: CommunicatorService, $parse: any) => ({
      link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes) => {
        const eventInfo = $parse(attributes['componentCommunicator'])(scope);
        for (let key in eventInfo) {
          ngComponentCommunicatorService.subscribe(key, eventInfo[key]);
        }

        scope.$on('$destroy', () => {
          for (let key in eventInfo) {
            ngComponentCommunicatorService.release(key, eventInfo[key]);
          }
        });
      }
    })
  ]);
export * from './lib/communicator';
export const communicator = 'ui-ng-component-communicator';



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-component-communicator/src/main.ts